import React, { FC, useState } from "react";
import s from "./SubdivisionForm.less";
import Input from "~/shared/ui/Fields/Input";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Button from "~/shared/ui/Fields/Button";
import {
  useAddNotificationMutation,
  useCheckListCommentSetterMutation,
} from "~/schemas/generated/graphql";
import { NOTIFICATIONS } from "~/constans/notifications";

interface IProps {
  checklistId: string;
}

const SubChecklistCommentForm: FC<IProps> = ({ checklistId }) => {
  const { t } = useTranslation();
  const [addNotificationMutation] = useAddNotificationMutation({});

  const schema = yup.object().shape({
    comment: yup
      .string()
      .test(
        "comment",
        t("validation.required"),
        (value) => !value || !!value.trim()
      )
      .max(250, t("validation.more250"))
      .required(t("validation.required")),
  });

  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
    watch,
  } = useForm({
    resolver: yupResolver(schema),
  });

  const [setCreateCheckListCommentMutation, createCheckListCommentMutation] =
    useCheckListCommentSetterMutation({
      onCompleted() {
        reset();
        addNotificationMutation({
          variables: {
            type: NOTIFICATIONS.success,
            content: t("common.adding_was_successful"),
          },
        });
      },
      onError({ graphQLErrors, networkError }) {
        let errorMessage = "Необходимо заполнить «Внешний код чек-листа».";
        if (graphQLErrors && graphQLErrors.length > 0) {
          const validationError = graphQLErrors.find(
            (error) =>
              error.extensions?.validationErrors &&
              error.extensions.validationErrors.length > 0
          );

          if (validationError) {
            const firstValidationError =
              validationError.extensions.validationErrors[0];
            if (
              firstValidationError &&
              firstValidationError.messages &&
              firstValidationError.messages.message
            ) {
              errorMessage = firstValidationError.messages.message;
            }
          }
        }
        addNotificationMutation({
          variables: {
            type: NOTIFICATIONS.error,
            content: errorMessage,
          },
        });
      },
    });

  const onSubmit = (data) => {
    setCreateCheckListCommentMutation({
      variables: {
        checkListId: String(checklistId),
        text: String(data.comment),
      },
    });
  };

  return (
    <form className={s.gr_v_form} onSubmit={handleSubmit(onSubmit)}>
      <ul className={s.list}>
        <li>
          <Input
            name="comment"
            label={`${t("Отправить комментарий")}`}
            error={errors["comment"]?.message}
            control={control}
            customClassName={s.select_width}
          />
        </li>
        <li className={s.with_btn}>
          <Button
            txtBtn={t("ui.add")}
            isForm={true}
            loading={createCheckListCommentMutation.loading}
          />
        </li>
      </ul>
    </form>
  );
};
export default SubChecklistCommentForm;
